import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);
const lazy = new LazyLoad();

export function heroSlider() {

    let hero_options = {
        loop: true,
        speed: 3000,
        on: {
            init: function () {
                lazy.update()
            },
            slideChange: function () {
                lazy.update()
            },
        },

        autoplay: {
            delay: 4000,
        },
        pagination: {
            el: '#hero-slider .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '" ><svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><circle stroke="white" stroke-width="3" cx="4" cy="4" r="4" fill="white"></circle></svg></span>';
            },
        },

        uniqueNavElements: false,

        navigation: {
            nextEl: '#hero-slider .js-slider-next',
            prevEl: '#hero-slider .js-slider-prev',
        },

        breakpoints: {
            320: {
                autoHeight: true,
                direction: 'horizontal',
            },
            700: {
                autoHeight: false,
            },
            1280: {
                direction: "vertical",
            }
        }
    };

    let hero = new Swiper("#hero-slider .swiper-container", hero_options);

    // console.log(hero);
}